import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useLocation} from "react-router-dom";
import {Button, Grid, Paper, Typography} from "@mui/material";
import {makeStyles} from '@mui/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination} from "swiper";
import "swiper/swiper-bundle.css";
import {format, parse} from "date-fns";
import {newRequestApi, showPopupVideo, isWidget, slideUp, slideDown, bookingActions} from "../../utils/utils";
import CardTripAccordionLoader from "./CardTripAccordionLoader";
import Player from '../Player/Player'

import {AiOutlinePlayCircle as IconPlay} from "react-icons/ai";
import CardTripAccordionRow from './CardTripAccordionRow';

SwiperCore.use([Pagination]);

const useStyles = makeStyles(() => ({
    // card wrapper
    cardWrapper: {
        marginBottom: '50px', position: 'relative'
    },

    card: {
        margin: 0, display: 'grid', gridTemplateColumns: '33.333% 1fr', '@media (max-width: 1024px)': {
            display: 'block',
        },
    },

    // card slider
    cardSlider: {
        position: 'relative', backgroundColor: '#333', userSelect: 'none', minHeight: '280px',
    },

    cardSliderItem: {
        position: 'relative', width: '100%', height: '100%', minHeight: '295px',

        "&:before": {
            content: '""', display: 'block', paddingBottom: '93.9%'
        }, '@media (max-width: 1024px)': {
            "&:before": {
                paddingBottom: '50%'
            },
        },
    },

    cardSliderImage: {
        position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', objectFit: 'cover'
    },

    cardSliderHeader: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        top: '0',
        right: '0',
        zIndex: 3,

        '@media (max-width: 1024px)': {
            padding: '12px 20px', width: '100%'
        },
        '@media (max-width: 480px)': {
            padding: '8px 10px',
        }
    },

    cardSliderInfo: {
        display: 'none',

        '@media (max-width: 1024px)': {
            flex: '1 1 auto', gap: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        },
    },

    buttonOpenPopup: {
        padding: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        background: 'transparent',
        zIndex: 1,
        border: 'none',
        fontSize: '70px',
        cursor: 'pointer',
        transition: '0.5s',
        '&:hover': {
            transform: 'scale(1.05)',
        },
        '@media (max-width: 480px)': {
            fontSize: '60px',
        },
    },

    // card content

    content: {
        display: 'grid', gridTemplateRows: 'auto 1fr', '@media (max-width: 1024px)': {
            padding: '30px',
        },
    },

    header: {
        padding: '10px 15px',
        borderBottom: '1px solid #C0C0C0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (max-width: 1024px)': {
            display: 'none'
        },
    },

    body: {
        padding: '15px 0', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', '@media (max-width: 1024px)': {
            display: 'block', padding: '0px'
        },
    },

    column: {
        fontSize: '16px', padding: '3px 20px', '&:first-child': {
            borderRight: '1px solid #C0C0C0',
        }, '&:last-child': {
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
        }, '@media (max-width: 1024px)': {
            padding: '0px', '&:first-child': {
                paddingBottom: '20px', marginBottom: '12px', borderRight: 'none', borderBottom: '1px solid #C0C0C0',
            }, '&:last-child': {
                display: 'block',
            },
        },
    },

    extraList: {
        padding: '0 10px',
        margin: '0 0 20px 0',
        display: 'grid',
        gap: '15px 10px',
        gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
        '& li': {
            listStyle: 'none', display: 'flex', alignItems: 'center'
        },
        '@media (max-width: 1024px)': {
            gap: '25px 15px', gridTemplateColumns: 'repeat(3, 1fr)', maxWidth: '440px', margin: '0 auto 20px auto'
        },
        '@media (max-width: 600px)': {
            gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', maxWidth: 'unset',
        },
    },


    extraText: {
        color: '#000', fontSize: '14px', display: 'inline-flex',
    },

    extraLink: {
        position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', zIndex: '2', cursor: 'pointer'
    },

    actionFooter: {
        marginBottom: '10px', '@media (max-width: 1024px)': {
            marginBottom: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center'
        }, '@media (max-width: 600px)': {
            display: 'block',
        },
    },

    accordeon: {
        backgroundColor: '#F3F3F3', display: 'none'
    }, accordeonBody: {},

	accordeonTitle:{
		padding: '20px 20px 20px 49px',
		fontWeight: 700,
		position: 'relative',
		cursor: 'pointer',
		transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		'&:hover': {
            backgroundColor: '#C0C0C0 !important',
			boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        },
	},

    icon: {
        position: 'relative', color: '#000', flex: '1 1 100px', filter: 'grayscale(100%)'
    }, available: {
        color: '#F50802', fontSize: '1.5rem'
    }, price: {
        fontWeight: '700', fontSize: '2.5rem'
    }, sub: {
        verticalAlign: 'super', fontSize: '12px',
    },
}));

const CardTripAccordion = ({tripClass, searchForm, destinationId}) => {
    const {
        h_description, h_slide_pictures, h_link, h_link_bex, h_video, features, tripClassId
    } = tripClass;
    const [openAccordeon, setOpenAccordeon] = useState(false);
    const [paginator, setPaginator] = React.useState({
        page: 1, query: {}, lastPage: 1, buttonMore: false
    });
    const [trips, setTrips] = useState([]);
    const [loading, setLoading] = useState(true);
    const [airplane, setAirplane] = useState(
        trips.some((trip) =>
            Array.isArray(trip.adventures) &&
            trip.adventures.some((adventure) =>
                adventure.name.includes('Spotter airplane')
            )
        )
    );
    const description = h_description !== null ? String(h_description) : [];
    const tripImageSlides = h_slide_pictures !== null ? JSON.parse(h_slide_pictures) : [];

    const classes = useStyles();
    const {siteUrl} = window;
	const nautilusSite = siteUrl.includes("nautilusdive");
    const {search} = useLocation();
    const searchParams = new URLSearchParams(search);
    let destinationP = searchParams.get('destination');
    const destinationIdP = searchParams.get('destinationId');
    const [showByDestinationStr, setShowByDestinationStr] = useState(false);
    const [show, setShow] = useState(false);
    const [isFiltered, setIsFiltered] = useState(false);
    const [isOnlyDealerTrips, setIsOnlyDealerTrips] = useState(searchForm.onlyDealerTrips??false);
    const [isStringDestination, setIsStringDestination] = useState(false);
    const destinationsData = {
        socorro: [3, 5],
        cocos: [23, 25, 52],
        expedition: [57],
        guadalupe: [4, 6, 9],
        cabopulmo: [18],
        seacortez: [12, 17, 21, 28, 30, 32, 37, 42, 47],
        bahia: [19, 22],
        sanignacio: [20, 62, 67],
        mobula: [27],
        ultimate: [29],
        marlin: [22]
    };

    useEffect(() => {
        const isFilteredCondition = ((destinationP !== null && tripClass.tripClassId === parseInt(destinationP)) || (searchForm.destination !== '' && tripClass.tripClassId === searchForm.destination)) || ((destinationIdP !== null && destinationId === parseInt(destinationIdP)) || (searchForm.destinationId !== '' && destinationId === searchForm.destinationId));

        setIsFiltered(isFilteredCondition);

        if ((((destinationIdP === null && destinationP === null) && searchForm.destination === '') && trips.length > 0) || isFilteredCondition) {
            setShow(true);
        }
        else
            setShow(false);
    }, [destinationIdP, destinationP, searchForm.destination, searchForm.destinationId, tripClass.tripClassId, trips.length]);

    useEffect(() => {
        const checkDestination = () => {
            if (!isStringDestination) {
                setShowByDestinationStr(false);
                return;
            }

        // Check if destination is in destinationsData and if tripClass.tripClassId is valid
        const destination = destinationP.toLowerCase();
        const validIds = destinationsData[Object.keys(destinationsData).find(key => destination.includes(key))];

            if (!validIds || !validIds.includes(tripClass.tripClassId)) {
                setShowByDestinationStr(false);
                setShow(false);
            } else {
                setShowByDestinationStr(true);
                setShow(false);
            }
        };

        checkDestination();
		// console.log(features);
    }, [destinationP, tripClass.tripClassId, isStringDestination]);

    useEffect(() => {
        const determineIsStringDestination = async () => {
            if (isFiltered) {
                setIsStringDestination(false);
            } else {
                const isString = typeof destinationP === 'string' && Object.keys(destinationsData).some(word => destinationP.toLowerCase().includes(word));
                setIsStringDestination(isString);

            }
        };

        determineIsStringDestination();
    }, [isFiltered, destinationP, destinationsData]);

	useEffect(() => {
		setAirplane(trips?.some(trip => Array.isArray(trip?.adventures) && trip.adventures.some(adventure => adventure.name.includes('Spotter airplane'))))
	}, [siteUrl, searchParams])


    const actionAccordeon = (e) => {
        setOpenAccordeon(!openAccordeon);
        const target = e.target;
        target.style.pointerEvents = 'none';
        setTimeout(() => target.style.pointerEvents = '', 700);
        const parent = target.closest('[data-card]');
        const accordeon = parent.querySelector('[data-accordeon]');
        !accordeon ? false : !openAccordeon ? slideDown(accordeon) : slideUp(accordeon);
        if(!openAccordeon)
            bookingActions('Availability Page','Show Destination Trip List', tripClass.class)
    }

	const actionSubAccordeon = (e) => {
        const target = e.target;
        target.style.pointerEvents = 'none';
        setTimeout(() => target.style.pointerEvents = '', 700);
		if(target.classList.contains('active')){
			slideUp(target.nextElementSibling);
			target.classList.remove('active')
			target.querySelector('.keyboard-arrow').style.transform = 'rotate(180deg)'
		}else{
			slideDown(target.nextElementSibling);
			target.classList.add('active');
			target.querySelector('.keyboard-arrow').style.transform = 'rotate(0deg)'
		}
    }

    const getTrips = async (id, params = {}) => {

        const filteredKeys = Object.keys(params).filter(k => params[k]);
        let filteredParams = {};

        for (const [key, value] of searchParams) {
            if(key!=='apiKey')
            filteredParams[key] = value;
        }

        for (let key of filteredKeys) {
            filteredParams[key] = params[key];
        }

        let page = 1;
        const query = {...filteredParams, page};
        if(isFiltered && parseInt(filteredParams['destination'])>0 && parseInt(id) !==parseInt(filteredParams['destination']))
            return;

        const {data} = await newRequestApi(`/get-trips-by-class/${id}`, 'GET', query, null, true);

        if ('data' in data) {
            setTrips(data['data']['data']);
            page = data['data']['current_page'];
            const lastPage = data['data']['last_page'];
            const buttonMore = parseInt(page) === parseInt(lastPage);
            setPaginator({page, query, lastPage, buttonMore});
            setLoading(false);
        }

    }

    useEffect(() => {
        const fetchData = async () => {
            const {year, month, adventure, location, hideUnavailable, space, destination, destinationId, onlyDealerTrips} = searchForm;
            await getTrips(tripClassId, {
                year,
                month,
                adventure,
                location,
                hideUnavailable,
                space,
                destination,
                destinationId,
                onlyDealerTrips
            });
        };

        fetchData();
    }, [searchForm.year, searchForm.destination, searchForm.destinationId, searchForm.month, searchForm.adventure, searchForm.location, searchForm.hideUnavailable, searchForm.space, searchForm.onlyDealerTrips]);

    useEffect( ()=>{
        if(isWidget())
            setIsOnlyDealerTrips(searchForm.onlyDealerTrips);
    },[searchForm.onlyDealerTrips])
    async function seeMore(tripClassId) {
        let {page, query} = paginator;
        page++;
        const {data} = await newRequestApi(`/get-trips-by-class/${tripClassId}`, 'GET', {...query, page});
        // console.log(data);
        if ('data' in data) {
            setTrips(trips.concat(data['data']['data']));
            page = data['data']['current_page'];
            const lastPage = data['data']['last_page'];
            const buttonMore = parseInt(page) === parseInt(lastPage);
            setPaginator({...paginator, page, lastPage, buttonMore});
        }
    }

    return (<>
        {loading && <CardTripAccordionLoader/>}
        {((showByDestinationStr || show) && <Paper elevation={3} className={classes.cardWrapper} data-card>
            {airplane &&
                <div className='airplane'><img src={`${siteUrl}/images/airplane.png`} alt="airplane"/></div>}
            <div className={classes.card}>
                <div className={classes.cardSlider}>
                    <div className={classes.cardSliderHeader}>
                        <div className={classes.cardSliderInfo}>
                            <Typography
                                gutterBottom
                                variant="h3"
                                component="h3"
                                sx={{
                                    color: '#fff',
                                    margin: 0,
                                    letterSpacing: '1px',
                                    fontSize: {xs: '14px', sm: '18px'},
                                }}
                            >
                                {tripClass.class && <span
                                    style={{fontWeight: 600, marginBottom: '5px'}}>{tripClass.class}</span>}
                            </Typography>
                        </div>
                    </div>
                    {tripImageSlides !== null && tripImageSlides.length > 1 ? <Swiper
                        style={{height: '100%'}}
                        modules={[Pagination]}
                        pagination={{clickable: true}}
                        spaceBetween={0}
                        slidesPerView={1}
                    >
                        {tripImageSlides.map((tripImageSlide, index) => (
                            <SwiperSlide className={classes.cardSliderItem} key={index}>
                                <img src={tripImageSlide} alt={tripClass.class}
                                     className={classes.cardSliderImage}/>
                            </SwiperSlide>))}
                    </Swiper> : tripImageSlides !== null && tripImageSlides.map((tripImageSlide, index) => (
                        <div className={classes.cardSliderItem} key={index}>
                            <img src={tripImageSlide} alt={tripClass.class}
                                 className={classes.cardSliderImage}/>
                        </div>))}
                    {h_video !== null && <button
                        type="button"
                        className={classes.buttonOpenPopup}
                        style={{height: tripImageSlides !== null && tripImageSlides.length > 1 && 'calc(100% - 45px)'}}
                        onClick={() => showPopupVideo({
                            title: tripClass.class,
                            html: <Player url={`https://www.youtube.com/watch?v=${h_video}`}/>
                        })}
                    >
                        <IconPlay color='#fff' style={{
                            position: 'relative',
                            top: tripImageSlides !== null && tripImageSlides.length > 1 && '22.5px'
                        }}/>
                    </button>}
                    <div className={classes.cardSliderNavigation}></div>
                </div>
                <div className={classes.content}>
                    <div className={classes.header}>
                        <Typography
                            gutterBottom
                            variant="h3"
                            component="h3"
                            sx={{fontSize: '21px', margin: 0}}
                        >
                            {tripClass.class && <strong>{tripClass.class}</strong>}
                        </Typography>
                    </div>
                    <div className={classes.body}>
                        <div className={classes.column}>
                            {!isWidget() && description.length > 0 && description.length > 350 ? <>{description.slice(0, 350)}...&nbsp;
                                {(h_link !== null || h_link_bex !== null) && <Button
                                    href={nautilusSite ? h_link : h_link_bex}
                                    sx={{
                                        display: 'inline-flex',
                                        lineHeight: 'unset',
                                        letterSpacing: 'unset',
                                        verticalAlign: 'unset',
                                        padding: 0,
                                        fontWeight: '400',
                                        fontSize: '16px',
                                        color: '#00b7f0 !important',
                                        whiteSpace: 'nowrap',
                                        ':hover': {backgroundColor: 'transparent'},
                                    }}
                                >
                                    Read more&nbsp;<i>&gt;</i>
                                </Button>}</> : description}
                        </div>
                        <div className={classes.column}>
                            <ul className={classes.extraList}>
                                {features && features.length > 0 &&  features.map((feature, index) => (
									(feature.name === 'Guest Reviews' && isWidget()) ? (
										<React.Fragment key={index} />
									) : (
										<li className='CardTripTitle' key={index} style={{ position: 'relative' }}>
											<span style={{ display: 'flex', flex: '0 0 27px', marginRight: '3px' }}>
												<img src={feature.icon} alt={feature.name} className={classes.icon} />
											</span>
											<span className={classes.extraText}>{feature.name}</span>
											{feature?.href && feature.href !== null && feature.href !== undefined && (
												<a href={feature.href} className={classes.extraLink} />
											)}
										</li>
									)
								))}
                            </ul>
                            <div className={classes.actionFooter}>
                                {trips.length > 0 ? <Button
                                    sx={{
                                        marginBottom: '10px',
                                        position: 'relative',
                                        fontWeight: 500,
                                        width: '100%',
                                        boxShadow: 'none',
                                        backgroundColor: '#F3F3F3',
                                        color: '#000',
                                        '@media (max-width: 1024px)': {
                                            order: '2', maxWidth: '300px', margin: 0,
                                        },
                                        '@media (max-width: 600px)': {
                                            maxWidth: '100%', marginBottom: '15px',
                                        },
                                        ":hover": {
                                            backgroundColor: '#C0C0C0',
                                        }
                                    }}
                                    variant={'contained'}
                                    fullWidth
                                    onClick={(e) => actionAccordeon(e)}
                                >
                                    {openAccordeon ? 'Hide departures' : 'Show departures'}
                                    <KeyboardArrowDownIcon
                                        sx={{
                                            fontSize: '25px !important',
                                            position: 'absolute',
                                            right: '20px',
                                            top: '9px',
                                            transition: 'transform 0.3s ease',
                                            transform: openAccordeon ? 'rotate(180deg)' : 'rotate(0deg)'
                                        }}
                                    />
                                </Button> : <Button
                                    sx={{
                                        marginBottom: '10px',
                                        position: 'relative',
                                        fontWeight: 500,
                                        width: '100%',
                                        boxShadow: 'none',
                                        backgroundColor: '#F3F3F3',
                                        color: '#000 !important',
                                        '@media (max-width: 1024px)': {
                                            order: '2', maxWidth: '300px', margin: 0,
                                        },
                                        '@media (max-width: 600px)': {
                                            maxWidth: '100%', marginBottom: '15px',
                                        },
                                        ":hover": {
                                            backgroundColor: '#C0C0C0',
                                        }
                                    }}
                                    variant={'contained'}
                                    fullWidth
                                    href={` https://nautilusliveaboards.com/contact-us/?subject=${tripClass.class}`}
                                >
                                    Contact us
                                    <LocalPostOfficeOutlinedIcon
                                        sx={{
                                            fontSize: '25px !important',
                                            position: 'absolute',
                                            right: '20px',
                                            top: '9px',
                                        }}
                                    />
                                </Button>}
                                {trips.length > 0 && trips[0]?.boarddate ? <Typography variant="p" component="p"
                                                                                       sx={{
                                                                                           '@media (max-width: 1024px)': {
                                                                                               marginRight: '20px',
                                                                                               marginLeft: 'auto',
                                                                                               order: '1'
                                                                                           },
                                                                                           '@media (max-width: 600px)': {
                                                                                               marginRight: '0',
                                                                                               marginLeft: '0',
                                                                                           },
                                                                                       }}
                                >
                                    <strong>Available departures</strong> from&nbsp;
                                    {`${format(parse(trips[0].boarddate, 'yyyy-MM-d', new Date()), 'MMM d')}th ${format(parse(trips[0].boarddate, 'yyyy-MM-d', new Date()), 'yyyy')}`}
                                </Typography> : <Typography variant="p" component="p"
                                                            sx={{
                                                                '@media (max-width: 1024px)': {
                                                                    marginRight: '20px',
                                                                    marginLeft: 'auto',
                                                                    order: '1'
                                                                }, '@media (max-width: 600px)': {
                                                                    marginRight: '0', marginLeft: '0',
                                                                },
                                                            }}
                                >
                                    <strong>Inquire</strong>
                                </Typography>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {trips.length > 0 && <div className={classes.accordeon} data-accordeon>
                <div className={classes.accordeonBody}>
                    {/* {trips.map((trip, index) => (searchForm.space === '' ? 
						<CardTripAccordionRow trip={trip} isOnlyDealerTrips={isOnlyDealerTrips} key={index}/> :
						parseInt(trip.available) >= parseInt(searchForm.space) ?
                        <CardTripAccordionRow isOnlyDealerTrips={isOnlyDealerTrips} trip={trip} key={index}/> :
						<></>))} */}
						{trips.reduce((acc, trip, index) => {
							const year = new Date(trip.boarddate).getFullYear();
							const currentYear = new Date().getFullYear();

							let backgroundColor;

							if (year === currentYear) {
								backgroundColor = '#F8F8F8';
							} else if (year - currentYear === 1) {
								backgroundColor = '#E0E0E0';
							} else if (year - currentYear === 2) {
								backgroundColor = '#D0D0D0';
							}else if (year - currentYear === 3) {
								backgroundColor = '#B8B8B8';
							}

							if (!acc.boarddate.includes(year)) {
								acc.boarddate.push(year);
								acc.elements.push(
									<div key={`title_${year}`} onClick={(e) => actionSubAccordeon(e)} className={classes.accordeonTitle + " active"} style={{ backgroundColor: backgroundColor }}>
										{year} {tripClass.class}
										<KeyboardArrowDownIcon
											sx={{
												fontSize: '25px !important',
												position: 'absolute',
												right: '20px',
												top: '20px',
												transition: 'transform 0.3s ease',
												pointerEvents: 'none',
												userSelect: 'none'
											}}
											className="keyboard-arrow"
										/>
									</div>
								);
								const rowsForYear = trips.filter(trip => new Date(trip.boarddate).getFullYear() === year);
								const rowsElements = rowsForYear.map((trip, rowIndex) => (
									<CardTripAccordionRow tripClassId={tripClassId} trip={trip} isOnlyDealerTrips={isOnlyDealerTrips} key={rowIndex} />
								));
								acc.elements.push(
									<div key={`body_${year}`} className="accordeon-body">
										{rowsElements}
									</div>
								);
							}
							return acc;
						}, { boarddate: [], elements: [] }).elements}
                </div>
                {!paginator.buttonMore && trips.length > 0 && <Grid sx={{margin: 0, padding: 0}}>
                    <Button
                        sx={{
                            position: 'relative',
                            fontWeight: 500,
                            width: '100%',
                            boxShadow: 'none',
                            backgroundColor: '#11486e',
                            color: '#fff',
                            ":hover": {
                                backgroundColor: '#1C75B5',
                            }
                        }}
                        fullWidth
                        onClick={() => seeMore(tripClass.tripClassId)}
                    >
                        See More
                    </Button>
                </Grid>}
            </div>}
        </Paper>)}
    </>);
};

export default CardTripAccordion;